import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useQuery from '../../../modules/react/hooks/useQuery';
import Popup from '../../../website/components/stateful/Popup';
import { GET_MEDIUM, getFilenameFromFeaturedImage } from './PopupBuilderContainer';

const propTypes = {
  isEditable: PropTypes.bool.isRequired,
  featuredImage: PropTypes.string,
  mediumId: PropTypes.string,
  popupHeaderText: PropTypes.string.isRequired,
  popupBodyContent: PropTypes.object.isRequired,
  popupIncludeForm: PropTypes.bool.isRequired,
  popupButtonText: PropTypes.string.isRequired,
  thankYouHeaderText: PropTypes.string.isRequired,
  thankYouBodyContent: PropTypes.object.isRequired,
  thankYouButtonText: PropTypes.string.isRequired,
  settingsTrigger: PropTypes.string.isRequired,
  settingsTimer: PropTypes.string.isRequired,
  settingsMobile: PropTypes.bool.isRequired,
  settingsLeadSource: PropTypes.string.isRequired,
};

const defaultProps = {};

const PopupContainer = ({
  isEditable,
  featuredImage,
  mediumId,
  popupHeaderText,
  popupBodyContent,
  popupIncludeForm,
  popupButtonText,
  thankYouHeaderText,
  thankYouBodyContent,
  thankYouButtonText,
  settingsTrigger,
  settingsTimer,
  settingsMobile,
  settingsLeadSource,
}) => {
  const [show, setShow] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const { data: mediumData } = useQuery(GET_MEDIUM, {
    variables: {
      id: mediumId,
      filename: getFilenameFromFeaturedImage(featuredImage),
    },
  });

  const medium = mediumData?.medium;

  const showPopup = () => {
    setShow(true);
    window.removeEventListener('scroll', onScroll);
  };

  // const onClose = () => setShow(false);
  const onClose = () => {
    setShow(false);
    setShowThankYou(false);
  };

  const onLeadFormSubmitted = () => {
    setShowThankYou(true);
  };

  const onScroll = () => {
    if (show) {
      return;
    }

    const { clientHeight, scrollHeight } = document.documentElement;
    // scrollTop is defined on different elements depending on the browser.
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const verticalCenterOfContent = (scrollHeight - clientHeight) / 2;

    // Show pop-up once the center of the viewport has scrolled past
    // half the content.
    if (scrollTop > verticalCenterOfContent) {
      showPopup();
    }
  };

  useEffect(() => {
    const isMobile = typeof window.orientation !== 'undefined';

    if (isEditable || (isMobile && settingsMobile)) {
      return;
    }

    if (settingsTrigger === 'time') {
      setTimeout(showPopup, settingsTimer * 1000);
      return;
    }

    if (settingsTrigger === 'scroll') {
      window.addEventListener('scroll', onScroll);
    }

    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Popup
      show={show}
      onClose={onClose}
      onLeadFormSubmitted={onLeadFormSubmitted}
      inAdminBuilder={isEditable}
      showThankYou={showThankYou}
      featuredImage={featuredImage}
      medium={medium}
      popupHeaderText={popupHeaderText}
      popupBodyContent={popupBodyContent}
      popupIncludeForm={popupIncludeForm}
      popupButtonText={popupButtonText}
      thankYouHeaderText={thankYouHeaderText}
      thankYouBodyContent={thankYouBodyContent}
      thankYouButtonText={thankYouButtonText}
      settingsLeadSource={settingsLeadSource}
    />
  );
};

PopupContainer.propTypes = propTypes;
PopupContainer.defaultProps = defaultProps;

export default PopupContainer;
